import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {SharedModule} from 'primeng/api';
import {Dialog} from 'primeng/dialog';
import {TenderContactPersonResponse} from '@frontend/shared-api';
import {LoadingComponent} from '../../../../../../../../shared/components/loading/loading.component';

@Component({
  selector: 'app-provider-contact-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, Dialog, SharedModule, LoadingComponent],
  templateUrl: './provider-contact-modal.component.html',
})
export class ProviderContactModalComponent {
  readonly visible = input.required<boolean>();
  readonly loading = input<boolean>(false);
  readonly contactPerson = input<TenderContactPersonResponse | null>(null);
  readonly providerName = input<string | null>(null);

  readonly visibleChange = output<boolean>();

  protected readonly displayProviderName = computed(() => this.providerName());
}
